import styled, { css } from "styled-components";

interface IProps {
    themeValue?: 'dark' | 'light';
}

export const SubtitleUI = styled.h3<IProps>`

font-size: 14px;

line-height: 18px;

p,strong,span{
    font-size: 14px; 
}

color: #06518f;

${props => props?.themeValue === 'dark' && css`
color: #fff;
`}

`